import ServiceApi from "../services/service.api";
const baseServiceUrl = `/api/v1/AmusementPackage`;


const ApiAmusementPackage = {
  getAllAmusementPackages: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getAmusementPackageById: (params) => {
    const url = `${baseServiceUrl}/${params}`;
    return ServiceApi.get(url);
  },
  createEditAmusementPackage: (params) => {
    const url = `${baseServiceUrl}/createEditAmusementPackage`;
    return ServiceApi.post(url, params);
  },
  updateAmusementPackage: (params) => {
    const url = `${baseServiceUrl}/updateAmusementPackage`;
    return ServiceApi.post(url, params);
  },
};

export default ApiAmusementPackage;